module.exports = __webpack_public_path__ + "static/media/Seam_3122.f15cd2fe.jpg";